import { Link } from "react-router-dom";

export default function PublicBrand({ surface = "light", className = "" }) {
  const src = surface === "dark" ? "/cleaniq-logo-light.webp" : "/cleaniq-logo.webp";

  return (
    <Link to="/" className={`block w-fit max-w-full ${className}`} aria-label="CleanIQ home">
      <img
        src={src}
        alt="CleanIQ — Clean Data. Smarter CRM."
        width="1000"
        height="488"
        className="max-h-14 w-auto max-w-full object-contain"
      />
    </Link>
  );
}
